import React, { FC } from "react";

import { KpkMedia } from "@keepeek/commons";
import { BaseComponentProps } from "@keepeek/refront-components";
import { Typography } from "@mui/material";
import clsx from "clsx";

type MediaDetailHeaderTechnicalInfoProps = {
  media: KpkMedia;
  headerSideField: string;
} & BaseComponentProps;

const MediaDetailHeaderSideMetaField: FC<
  React.PropsWithChildren<MediaDetailHeaderTechnicalInfoProps>
> = function ({ media, headerSideField, className }) {
  const metaField = media.fields?.find((f) => f.id === headerSideField);
  if (!metaField) {
    return null;
  }
  return (
    <>
      <Typography
        className={clsx("MediaDetailHeaderSideMetaField", className)}
        title={metaField.name}
        variant="subtitle1"
        noWrap
      >
        {metaField.value}
      </Typography>
    </>
  );
};

export default MediaDetailHeaderSideMetaField;
